module.exports = __webpack_public_path__ + "marianne.59060fc2fdc690c2b3dedbaa87e1ce2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/base/components/header/marianne.png
// module id = 276
// module chunks = 0